import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import * as leaderStore from '@/store/modules/leaderStore.js'
import * as eventStore from '@/store/modules/eventStore.js'

export default new Vuex.Store({
  modules: {
    leaderStore,
    eventStore
  },
  state: {
    categories: [
      'sustainability',
      'nature',
      'animal welfare',
      'housing',
      'education',
      'food',
      'community'
    ],
    todos: [
      { id: 1, text: '...', done: true },
      { id: 2, text: '...', done: false },
      { id: 3, text: '...', done: true },
      { id: 4, text: '...', done: false }
    ]
  },
  getters: {
    activeTodosCount: (state, getters) => {
      return state.todos.length - getters.doneTodos.length
    },
    catLength: state => {
      return state.categories.length
    },
    doneTodos: state => {
      return state.todos.filter(todo => todo.done)
    }
  }
})
